import React, {
	useCallback,
	useState
} from 'react';

import {
	validateEmail,
	validatePhone,
	wordCount,
	validateZip
} from '../../../services/validation';

import PhoneValidationInfoPopup from '../../Form/PhoneValidationInfoPopup';
import EmailValidationInfoPopup from '../../Form/EmailValidationInfoPopup';

const useFormErrors = () => {
	const [
		formErrors,
		setFormErrors
	] = useState( [] );

	const clearFormErrors = useCallback( () => {
		setFormErrors( [] );
	}, [] );

	const validateFormErrors = useCallback( () => formErrors.some( errs => errs.some( err => err.error ) ), [ formErrors ] );

	const handleValidation = useCallback( ( {
		data,
		label,
		validation
	} ) => {
		let errors = [];

		let {
			required,
			maxWords,
			format,
			minEntries
		} = validation;

		if ( required ) {
			if ( !minEntries ) {
				errors.push( {
					error: !data,
					message: `${ label } is a required field.`,
					fieldLabel: label
				} );
			} else { // is this necessary???
				errors.push( {
					error: data.length < minEntries,
					message: `At least ${ minEntries } ${ label } ${ minEntries < 2 ? 'is' : 'are' } required.`,
					fieldLabel: label
				} );
			}
		}

		if ( maxWords ) {
			errors.push( {
				error: Boolean( data ) && wordCount( data ) > maxWords,
				message: 'Entry exceeds the maximum number of allowed words.',
				fieldLabel: label
			} );
		}

		if ( format ) {
			switch ( format ) {
				case 'email':
					errors.push( {
						error: Boolean( data ) && !validateEmail( data ),
						message: <>Please enter a valid email address.&nbsp;<EmailValidationInfoPopup /></>,
						fieldLabel: label
					} );
					break;
				case 'phone':
					errors.push( {
						error: Boolean( data ) && !validatePhone( data ),
						message: <>Please enter a valid U.S. phone number.&nbsp;<PhoneValidationInfoPopup /></>,
						fieldLabel: label
					} );
					break;
				case 'zip':
					errors.push( {
						error: Boolean( data ) && !validateZip( data ),
						message: 'Please enter a valid, 5-digit zip code.',
						fieldLabel: label
					} );
					break;
				case 'url':
				// implement url validation
					break;
				default: {
					try {
						const regexp = new RegExp( format );
						// regex
						const validate = () => regexp.test( data );

						errors.push( {
							error: Boolean( data ) && !validate(),
							message: `Please enter a valid ${ label }`,
							fieldLabel: label
						} );
					} catch ( error ) {
						break;
					}
				}
			}
		}

		return errors;
	}, [] );

	return {
		clearFormErrors,
		formErrors,
		setFormErrors,
		handleValidation,
		validateFormErrors
	};
};

export default useFormErrors;
